import { ReactNode, useState, useEffect } from "react"

// UI
import {
	Tooltip as BaseTooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@/components/ui/tooltip"

interface TooltipProps {
	content: ReactNode
	children: ReactNode
	className?: string
	enabled?: boolean
	// Add support for mobile touch interactions
	delayDuration?: number
}

/**
 * Tooltip with improved mobile support
 * @param param0
 * @returns
 */
export function Tooltip({
	content,
	children,
	className = "",
	enabled = true,
	delayDuration = 200,
}: TooltipProps) {
	const [open, setOpen] = useState(false)
	const [isTouchDevice, setIsTouchDevice] = useState(false)

	useEffect(() => {
		// Check if device supports touch
		setIsTouchDevice(
			"ontouchstart" in window || navigator.maxTouchPoints > 0,
		)
	}, [])

	// Handle touch events for mobile
	const handleTouch = (e: React.TouchEvent) => {
		if (isTouchDevice) {
			e.preventDefault()
			setOpen(!open)
			// Auto-close after 3 seconds on mobile
			if (!open) {
				setTimeout(() => setOpen(false), 3000)
			}
		}
	}

	// Handle click for mobile devices
	const handleClick = (e: React.MouseEvent) => {
		if (isTouchDevice) {
			e.preventDefault()
			e.stopPropagation()
			setOpen(!open)
			// Auto-close after 3 seconds on mobile
			if (!open) {
				setTimeout(() => setOpen(false), 3000)
			}
		}
	}

	return (
		<>
			{enabled === true ? (
				<TooltipProvider delayDuration={delayDuration}>
					<BaseTooltip open={open} onOpenChange={setOpen}>
						<TooltipTrigger
							className={className}
							onTouchStart={handleTouch}
							onClick={handleClick}
							asChild
						>
							<span style={{ cursor: "pointer" }}>
								{children}
							</span>
						</TooltipTrigger>
						<TooltipContent>{content}</TooltipContent>
					</BaseTooltip>
				</TooltipProvider>
			) : (
				children
			)}
		</>
	)
}
